import { render, staticRenderFns } from "./DataSummary.vue?vue&type=template&id=0e48b29b&scoped=true&"
import script from "./DataSummary.vue?vue&type=script&lang=js&"
export * from "./DataSummary.vue?vue&type=script&lang=js&"
import style0 from "./DataSummary.vue?vue&type=style&index=0&id=0e48b29b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e48b29b",
  null
  
)

export default component.exports